import * as PIXI from "pixi.js";
import {app, events} from "../../utils/pixiApp";
import {Bet} from "./Bet";
import {Button} from "./Button";
import {getDeviceMedia} from "../../utils/sizes";

const sizes = {
    web: {
        height: 136,
        radius: 24
    },
    mobile: {
        height: 98,
        radius: 16
    }
}

export class Footer extends PIXI.Container {
    constructor() {
        super();
        this.mediaScreen = getDeviceMedia(app.screen.width)
        this.position.x = 0
        this.position.y = app.screen.height - sizes[this.mediaScreen].height;
        this.pivot.set(this.width / 2, this.height / 2)

        this.bg = new PIXI.Graphics()
        this.setBg()

        this.bet = new Bet(this.bg.width, this.bg.height, true)
        this.button = new Button(this.bg.width, this.bg.height)
        this.bg.addChild(this.bet, this.button)
        this.addChild(this.bg);

        events.onScreenResizeEvent(() => {
            this.resizeView();
        })
    }

    setBg() {
        this.bg.clear()
        this.bg
            .moveTo(sizes[this.mediaScreen].radius, 0)
            .lineTo(app.screen.width - sizes[this.mediaScreen].radius, 0)
            .quadraticCurveTo(app.screen.width, 0, app.screen.width, sizes[this.mediaScreen].radius)
            .lineTo(app.screen.width, sizes[this.mediaScreen].height)
            .lineTo(0, sizes[this.mediaScreen].height)
            .lineTo(0, sizes[this.mediaScreen].radius)
            .quadraticCurveTo(0, 0, sizes[this.mediaScreen].radius , 0)
            .fill({ color: 'rgba(2, 19, 32, 0.2)' })
    }

    resizeView() {
        const media = getDeviceMedia(app.screen.width)
        if(this.mediaScreen !== media || media !== 'web') {
            if(this.mediaScreen !== media) {
                this.mediaScreen = media
            }
            this.position.y = app.screen.height - sizes[this.mediaScreen].height;
            this.setBg();
            this.bet.setSizes(app.screen.width, sizes[this.mediaScreen].height, media)
            this.button.setSizes(app.screen.width, sizes[this.mediaScreen].height, media)
        }
    }
}